"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

var _moment = _interopRequireDefault(require("../../lib/moment"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _TicketDetails = _interopRequireDefault(require("../02_molecules/TicketDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var OrdersListWidget = function OrdersListWidget(_ref) {
  var tickets = _ref.tickets,
      _ref$isFiltered = _ref.isFiltered,
      isFiltered = _ref$isFiltered === void 0 ? false : _ref$isFiltered,
      _ref$onUnfilter = _ref.onUnfilter,
      onUnfilter = _ref$onUnfilter === void 0 ? function () {} : _ref$onUnfilter,
      translationManager = _ref.translationManager,
      t = _ref.translator;
  // Sort tickets by descending departing order
  tickets.sort(function (a, b) {
    return (0, _moment["default"])(b.ticketDetails.departureTime).valueOf() - (0, _moment["default"])(a.ticketDetails.departureTime).valueOf();
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, tickets.map(function (ticket) {
    var topRightLabel = null;
    var hasExpired = (0, _moment["default"])(ticket.ticketDetails.arrivalTime).valueOf() < (0, _moment["default"])().add(1, 'hours').valueOf();
    var _ticket$statusDetails = ticket.statusDetails,
        _ticket$statusDetails2 = _ticket$statusDetails.booked,
        booked = _ticket$statusDetails2 === void 0 ? true : _ticket$statusDetails2,
        _ticket$statusDetails3 = _ticket$statusDetails.cancelled,
        cancelled = _ticket$statusDetails3 === void 0 ? false : _ticket$statusDetails3;

    if (cancelled) {
      topRightLabel = {
        color: 'red',
        content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "cancel"
        }), t('Order cancelled'))
      };
    } else if (!booked) {
      topRightLabel = {
        color: 'orange',
        content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "wait"
        }), t('Order in process'))
      };
    } else {
      topRightLabel = {
        color: 'green',
        content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "check"
        }), t('Order confirmed'))
      };
    }

    var style = {};

    if (hasExpired) {
      style = {
        opacity: '0.5'
      };
    }

    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "/tickets/".concat(ticket.id)
    }, /*#__PURE__*/_react["default"].createElement(_TicketDetails["default"], {
      id: "ticket-thumb_".concat(ticket.id),
      key: "ticket-thumb_".concat(ticket.id),
      elementStyle: style,
      topRightLabel: topRightLabel,
      ticketDetails: ticket.ticketDetails,
      nPassengers: _checkTypes["default"].nonEmptyArray(ticket.ticketDetails.passengers) ? ticket.ticketDetails.passengers.length : 1,
      expired: hasExpired,
      locale: translationManager.getCurrentLanguage(),
      titlePadding: 10,
      backgroundColor: "white"
    }));
  }), isFiltered && /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    fluid: true,
    onClick: onUnfilter
  }, t('Show all tickets')))));
};

var _default = OrdersListWidget;
exports["default"] = _default;